import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import {
  ChevronLeft as ChevronLeftIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowBack as ArrowBackIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  BarChart as BarChartIcon,
  HelpOutlined as HelpOutlineIcon,
  ArrowUpward as ArrowUpwardIcon,
  Description as DescriptionIcon,
  Layers as LayersIcon,
  CreateNewFolder as CreateNewFolderIcon,
  PictureAsPdf as PictureAsPdfIcon,
  VideoLibrary as VideoLibraryIcon,
  LibraryMusic as LibraryMusicIcon,
  InsertDriveFile as InsertDriveFileIcon,
  Straighten as StraightenIcon,
  Stairs as StairsIcon,
  Computer as ComputerIcon,
  InfoOutlined as InfoOutlinedIcon,
  Image as ImageIcon,
  Edit as EditIcon,
  FormatListBulleted as FormatListBulletedIcon,
  FileUploadOutlined as FileUploadOutlinedIcon,
  MoreHoriz as MoreHorizIcon,
  PersonAdd as PersonAddIcon,
  ContactPage as ContactPageIcon,
  OpenInNew as OpenInNewIcon,
  PlaylistAddCheck as PlaylistAddCheckIcon,
  LibraryAdd as LibraryAddIcon,
  VerticalAlignTop as VerticalAlignTopIcon,
  Folder as FolderIcon,
  BackspaceOutlined as BackspaceOutlinedIcon,
  Lock as LockIcon,
  LockOpen as LockOpenIcon,
  NoteAltOutlined as NoteAltOutlinedIcon,
  Star as StarIcon,
  TaskAlt as TaskAltIcon,
  Storage as StorageIcon,
  StarBorder as StarBorderIcon,
  CloudUploadOutlined as CloudUploadOutlinedIcon,
  EventOutlined as EventOutlinedIcon,
  HighlightOff as HighlightOffIcon,
  ErrorOutlined as ErrorOutlineIcon,
  SpaceDashboard as SpaceDashboardIcon,
  FlashOnSharp as FlashOnSharpIcon,
  EnergySavingsLeaf as EnergySavingsLeafIcon,
  Power as PowerIcon,
  Apartment as ApartmentIcon,
  Add as AddIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  WarningAmber as WarningAmberIcon,
  Sunny as SunnyIcon,
  MoreVert as MoreVertIcon,
  Speed as SpeedIcon,
  QrCode2Outlined as QrCode2OutlinedIcon,
  Savings as SavingsIcon,
  Lightbulb as LightbulbIcon,
  Dashboard as DashboardIcon,
  Sensors as SensorsIcon,
  OpenWith as OpenWithIcon,
  DesignServices as DesignServicesIcon,
  Map as MapIcon,
  Business as BusinessIcon,
  Analytics as AnalyticsIcon,
  ViewInAr as ViewInArIcon,
  Settings as SettingsIcon,
  Feedback as FeedbackIcon,
  ChevronRight as ChevronRightIcon,
  Home as HomeIcon,
  Tune as TuneIcon,
  Memory as MemoryIcon,
  Category as CategoryIcon,
  People as PeopleIcon,
  Contrast as ContrastIcon,
  Assignment as AssignmentIcon,
  Code as CodeIcon,
  Cloud as CloudIcon,
  Close as CloseIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  NotificationsActive as NotificationsActiveIcon,
  SignalCellularAlt as SignalCellularAltIcon,
  FolderOpen as FolderOpenIcon,
  CloudQueue as CloudQueueIcon,
  LanOutlined as LanOutlinedIcon,
  SellOutlined as SellOutlinedIcon,
  ElectricalServices as ElectricalServicesIcon,
  BusinessCenterOutlined as BusinessCenterOutlinedIcon,
  KeyOutlined as KeyOutlinedIcon,
  SmsOutlined as SmsOutlinedIcon,
  NotificationsOutlined as NotificationsOutlinedIcon,
  EventAvailableOutlined as EventAvailableOutlinedIcon,
  TuneOutlined as TuneOutlinedIcon,
  ThumbUpOutlined as ThumbUpOutlinedIcon,
  CheckBoxOutlined as CheckBoxOutlinedIcon,
  Delete as DeleteIcon,
  SearchOutlined as SearchOutlinedIcon,
  Save as SaveIcon,
  CircleOutlined as CircleOutlinedIcon,
  ContentCopy as ContentCopyIcon,
  CloudOutlined as CloudOutlinedIcon,
  AssignmentOutlined as AssignmentOutlinedIcon,
  CameraAltOutlined as CameraAltOutlinedIcon,
  CheckOutlined as CheckOutlinedIcon,
  EvStationOutlined as EvStationOutlinedIcon,
  Battery4BarOutlined as Battery4BarOutlinedIcon,
  ThermostatAuto as ThermostatAutoIcon,
  DeviceThermostat as DeviceThermostatIcon,
  SolarPower as SolarPowerIcon,
  Air as AirIcon,
  ModeFanOff as ModeFanOffIcon,
  AcUnit as AcUnitIcon,
  Warehouse as WarehouseIcon,
  AccessTimeOutlined as AccessTimeOutlinedIcon,
  PersonOutlined as PersonOutlinedIcon,
  BusinessOutlined as BusinessOutlinedIcon,
  BorderColorOutlined as BorderColorOutlinedIcon,
  FileDownloadOutlined as FileDownloadOutlinedIcon,
  LoopOutlined as LoopOutlinedIcon,
  AreaChartOutlined as AreaChartOutlinedIcon,
  DoneAllOutlined as DoneAllOutlinedIcon,
  PieChart as PieChartIcon,
  ScatterPlot as ScatterPlotIcon,
  Radar as RadarIcon,
  ShowChart as ShowChartIcon,
  QueryStats as QueryStatsIcon,
  SaveOutlined as SaveOutlinedIcon,
  DescriptionOutlined as DescriptionOutlinedIcon,
  TouchAppOutlined as TouchAppOutlinedIcon,
  PolylineOutlined as PolylineOutlinedIcon,
  ViewInArOutlined as ViewInArOutlinedIcon,
  JoinInnerOutlined as JoinInnerOutlinedIcon,
  ContentCutOutlined as ContentCutOutlinedIcon,
  DeleteOutlined as DeleteOutlineIcon,
  AccountBalance as AccountBalanceIcon,
  AddCircleOutlined as AddCircleOutlineIcon,
  AttachFile as AttachFileIcon,
  AttachMoney as AttachMoneyIcon,
  AutoAwesome as AutoAwesomeIcon,
  Menu as MenuIcon,
  Calculate as CalculateIcon,
  Cancel as CancelIcon,
  CheckCircle as CheckCircleIcon,
  CheckCircleOutlined as CheckCircleOutlineIcon,
  Construction as ConstructionIcon,
  HandymanOutlined as HandymanOutlinedIcon,
  BuildOutlined as BuildOutlinedIcon,
  DragIndicator as DragIndicatorIcon,
  EditNote as EditNoteIcon,
  ExploreOutlined as ExploreOutlinedIcon,
  FormatListNumbered as FormatListNumberedIcon,
  Height as HeightIcon,
  History as HistoryIcon,
  Kitchen as KitchenIcon,
  LightbulbOutlined as LightbulbOutlinedIcon,
  Link as LinkIcon,
  LinkOff as LinkOffIcon,
  LocationOn as LocationOnIcon,
  MyLocation as MyLocationIcon,
  Opacity as OpacityIcon,
  PlayArrow as PlayArrowIcon,
  Polyline as PolylineIcon,
  Public as PublicIcon,
  Recycling as RecyclingIcon,
  Refresh as RefreshIcon,
  RemoveCircleOutlined as RemoveCircleOutlineIcon,
  Remove as RemoveIcon,
  Send as SendIcon,
  SwapHoriz as SwapHorizIcon,
  TableChart as TableChartIcon,
  NearMe as NearMeIcon,
  TrendingDown as TrendingDownIcon,
  TrendingFlat as TrendingFlatIcon,
  TrendingUp as TrendingUpIcon,
  Undo as UndoIcon,
  Weekend as WeekendIcon,
  Window as WindowIcon,
  WindowOutlined as WindowOutlinedIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  PropaneTankOutlined as PropaneTankOutlinedIcon,
  Restore as RestoreIcon,
  CropSquare as CropSquareIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
  Check as CheckIcon,
  AccountBalanceOutlined as AccountBalanceOutlinedIcon,
  PublishedWithChanges as PublishedWithChangesIcon,
  // No-alias barrel imports
  PeopleOutlined,
  SettingsOutlined,
  PaletteOutlined,
  SquareFootOutlined,
  Whatshot,
  FolderCopy,
  Straight,
  ArrowDropUp as ArrowDropUpIcon,
  ArrowDropDown as ArrowDropDownIcon,
  LocalOffer,
  WhatshotOutlined,
  HomeWorkOutlined,
  LabelOutlined,
  TagOutlined,
  MultipleStopOutlined,
  LowPriority,
  SensorsOutlined,
  SettingsInputAntenna,
  DeveloperBoard,
  DeviceHub,
  Fullscreen,
  FullscreenExit,
  FileDownload,
  CategoryOutlined,
  AcUnitOutlined,
  LayersOutlined,
  KitchenOutlined,
  WbSunnyOutlined,
  WeekendOutlined,
  FlashOnOutlined,
  LocalFireDepartmentOutlined,
  WaterDropOutlined,
  HomeOutlined,
  LocationOnOutlined,
  SolarPowerOutlined,
  WifiOutlined,
  ShareOutlined,
  ExtensionOutlined,
  DesktopWindowsOutlined,
  SecurityOutlined,
  PowerOutlined,
  LockOutlined as LockOutline,
  BalanceOutlined,
  DarkModeOutlined,
  DomainDisabled,
} from '@mui/icons-material';
import { EosIcon } from '../../../components/EosIcon';

const muiFallbackIconMap: Record<string, React.ElementType<SvgIconProps>> = {
  // Bolt / energy
  'fas fa-bolt': FlashOnSharpIcon,
  'fa-bolt': FlashOnSharpIcon,
  'fa-sharp-duotone fa-solid fa-bolt': FlashOnSharpIcon,

  // Leaf
  'fas fa-leaf': EnergySavingsLeafIcon,
  'fa-leaf': EnergySavingsLeafIcon,

  // Power / plug
  'fas fa-plug': PowerIcon,
  'fa-plug': PowerIcon,
  'fa-sharp-duotone fa-solid fa-plug': PowerOutlined,

  // Charging / battery
  'fa-sharp-duotone fa-solid fa-charging-station': EvStationOutlinedIcon,
  'fa-sharp-duotone fa-solid fa-battery-half': Battery4BarOutlinedIcon,

  // Temperature
  'fa-sharp-duotone fa-solid fa-temperature-high': DeviceThermostatIcon,
  'fa-sharp-duotone fa-solid fa-temperature-low': ThermostatAutoIcon,
  'fas fa-temperature-high': DeviceThermostatIcon,

  // Renewable / climate
  'fa-sharp-duotone fa-solid fa-solar-panel': SolarPowerIcon,
  'fa-sharp-duotone fa-solid fa-wind': AirIcon,
  'fa-sharp-duotone fa-solid fa-fan': ModeFanOffIcon,
  'fa-sharp-duotone fa-solid fa-snowflake': AcUnitIcon,

  // Building
  'fas fa-building': ApartmentIcon,
  'fa-building': ApartmentIcon,
  'fa-regular fa-building': BusinessOutlinedIcon,
  'fa-sharp-duotone fa-solid fa-building': ApartmentIcon,
  'fa-sharp-duotone fa-solid fa-house-chimney': HomeIcon,
  'fa-sharp-duotone fa-solid fa-warehouse': WarehouseIcon,

  // Add
  'fa-solid fa-plus': AddIcon,
  'fas fa-plus': AddIcon,
  'fa-plus': AddIcon,
  'fa-regular fa-plus': AddIcon,
  'fa-light fa-plus': AddIcon,

  // Expand / collapse
  'fas fa-chevron-down': ExpandMoreIcon,
  'fa-chevron-down': ExpandMoreIcon,
  'fa-solid fa-chevron-down': ExpandMoreIcon,
  'fa-duotone fa-solid fa-chevron-down': ExpandMoreIcon,
  'fas fa-chevron-up': ExpandLessIcon,
  'fa-chevron-up': ExpandLessIcon,
  'fa-solid fa-chevron-up': ExpandLessIcon,
  'fa-duotone fa-solid fa-chevron-up': ExpandLessIcon,
  'fas fa-chevron-right': ChevronRightIcon,
  'fa-duotone fa-solid fa-chevron-right': ChevronRightIcon,
  'fa-duotone fa-solid fa-chevron-left': ChevronLeftIcon,
  'fa-chevron-right': ChevronRightIcon,

  // Warning
  'fas fa-exclamation-triangle': WarningAmberIcon,
  'fa-exclamation-triangle': WarningAmberIcon,
  'fa-light fa-triangle-exclamation': WarningAmberIcon,

  // Weather / sun
  'fas fa-cloud-sun': SunnyIcon,
  'fas fa-cloud-sun chart-icon': SunnyIcon,
  'fas fa-sun': SunnyIcon,

  // More
  'fa-solid fa-ellipsis-v': MoreVertIcon,
  'fas fa-ellipsis-v': MoreVertIcon,
  'fa-ellipsis-v': MoreVertIcon,
  'fa-solid fa-ellipsis-vertical': MoreVertIcon,

  // Loading
  'fas fa-spinner fa-spin': LoopOutlinedIcon,
  'fa-spinner fa-spin': LoopOutlinedIcon,
  'fa-solid fa-spinner fa-spin': LoopOutlinedIcon,

  // Speed / gauge
  'fas fa-tachometer-alt': SpeedIcon,
  'fa-tachometer-alt': SpeedIcon,
  'fa-sharp-duotone fa-solid fa-gauge': SpeedIcon,

  // Savings
  'fas fa-piggy-bank': SavingsIcon,
  'fa-piggy-bank': SavingsIcon,

  // Light
  'fas fa-lightbulb': LightbulbIcon,
  'fa-lightbulb': LightbulbIcon,

  // EOS custom
  'fa-solid fa-diagram-sankey': EosIcon,

  // Dashboard / analytics
  'fas fa-chart-line': ShowChartIcon,
  'fa-sharp-duotone fa-solid fa-chart-line': ShowChartIcon,
  'fas fa-chart-bar': AnalyticsIcon,
  'fa-chart-pie': PieChartIcon,
  'fa-chart-scatter': ScatterPlotIcon,
  'fa-radar': RadarIcon,
  'fas fa-th-large': DashboardIcon,

  // Sensors / devices
  'fa-sensor': SensorsIcon,
  'fas fa-signal-stream': SensorsIcon,

  // Map
  'fas fa-map': MapIcon,

  // Business / organization
  'fas fa-city': BusinessIcon,
  'fa-briefcase': BusinessCenterOutlinedIcon,

  // 3D / model
  'fas fa-cube': ViewInArIcon,

  // Settings
  'fas fa-cog': SettingsIcon,
  'fa-gear': SettingsOutlined,

  // Feedback / comments
  'fas fa-comment-alt': FeedbackIcon,
  'fa-comment-dots': SmsOutlinedIcon,

  // Home
  'fas fa-home': HomeIcon,
  'fa-house-chimney': HomeIcon,
  'fa-light fa-house': HomeIcon,

  // Tune / filters
  'fas fa-sliders-h': TuneIcon,
  'fa-solid fa-sort': TuneOutlinedIcon,
  'fa-sliders': TuneOutlinedIcon,

  // Memory / chip
  'fas fa-microchip': MemoryIcon,
  'fa-microchip': MemoryIcon,
  'fa-light fa-microchip': MemoryIcon,

  // Tags / categories
  'fas fa-tags': CategoryIcon,
  'fa-regular fa-tags': CategoryIcon,
  'fa-tags': SellOutlinedIcon,
  'fa-solid fa-tags': SellOutlinedIcon,
  'fas fa-shapes': CategoryIcon,

  // Users
  'fas fa-users': PeopleIcon,
  'fa-users': PeopleOutlined,
  'fa-regular fa-user': PersonOutlinedIcon,

  // Contrast / themes
  'fas fa-adjust': ContrastIcon,
  'fa-palette': PaletteOutlined,

  // Assignment / clipboard
  'fas fa-clipboard-list': AssignmentIcon,
  'fas fa-clipboard-check': AssignmentTurnedInIcon,
  'fa-clipboard-check': EventAvailableOutlinedIcon,
  'fa-light fa-square-check': CheckBoxOutlinedIcon,
  'fa-clipboard-list': AssignmentOutlinedIcon,
  'fa-solid fa-clipboard-check': AssignmentTurnedInIcon,

  // Code / integrations
  'fas fa-code': CodeIcon,
  'fa-code': CodeIcon,

  // Cloud / files
  'fas fa-cloud': CloudIcon,
  'fa-cloud': CloudOutlinedIcon,
  'fa-sensor-cloud': CloudQueueIcon,

  // Close
  'fas fa-times': CloseIcon,
  'fa-solid fa-xmark': CloseIcon,

  // Notifications
  'fas fa-bell': NotificationsActiveIcon,
  'fa-bell': NotificationsOutlinedIcon,
  'fa-regular fa-bell': NotificationsOutlinedIcon,

  // Signal
  'fas fa-signal': SignalCellularAltIcon,

  // Folder
  'fa-folder-open': FolderOpenIcon,
  'fa-solid fa-folder-open': FolderOpenIcon,
  'fa-solid fa-folder': FolderIcon,

  // Network
  'fa-network-wired': LanOutlinedIcon,

  // Electrical
  'fa-plug-circle-bolt': ElectricalServicesIcon,

  // Security / key
  'fa-key': KeyOutlinedIcon,

  // Approval
  'fa-regular fa-thumbs-up': ThumbUpOutlinedIcon,

  // Delete
  'fas fa-trash-alt': DeleteIcon,
  'fa-regular fa-trash': DeleteOutlineIcon,
  'fa-regular fa-trash-can': DeleteOutlineIcon,

  // Search
  'fa-solid fa-magnifying-glass': SearchOutlinedIcon,

  // Save
  'fa-solid fa-save': SaveIcon,

  // Circle
  'fa-circle': CircleOutlinedIcon,

  // Clone / categories
  'fa-clone': ContentCopyIcon,

  // Image upload
  'fa-solid fa-camera': CameraAltOutlinedIcon,

  // Checkmark
  'fa-solid fa-check': CheckOutlinedIcon,

  // Clock
  'fa-regular fa-clock': AccessTimeOutlinedIcon,

  // Edit
  'fa-regular fa-pen-to-square': BorderColorOutlinedIcon,
  'fa-regular fa-edit': BorderColorOutlinedIcon,

  // File export
  'fa-regular fa-download': FileDownloadOutlinedIcon,

  // Chart
  'fas fa-chart-area': AreaChartOutlinedIcon,

  'fa-solid fa-table-columns': DashboardIcon,
  'fa-solid fa-tower-broadcast': SensorsIcon,
  'fa-solid fa-map': MapIcon,
  'fa-solid fa-building': ApartmentIcon,
  'fa-solid fa-square-poll-vertical': AnalyticsIcon,
  'fa-solid fa-cube': ViewInArIcon,
  'fa-solid fa-gear': SettingsOutlined,
  'fa-solid fa-message': FeedbackIcon,
  'fa-solid fa-house': HomeOutlined,
  'fa-light fa-house-chimney': HomeIcon,
  'fa-solid fa-sliders': TuneOutlinedIcon,
  'fa-light fa-sliders': TuneOutlinedIcon,
  'fa-solid fa-microchip': MemoryIcon,
  'fa-solid fa-shapes': CategoryIcon,
  'fa-solid fa-users': PeopleOutlined,
  'fa-solid fa-circle-half-stroke': ContrastIcon,
  'fa-solid fa-clipboard-list': AssignmentOutlinedIcon,
  'fa-solid fa-code': CodeIcon,
  'fa-solid fa-cloud': CloudOutlinedIcon,
  'fa-solid fa-sun': SunnyIcon,
  'fa-solid fa-bolt': FlashOnOutlined,
  'fa-solid fa-bell': NotificationsOutlinedIcon,
  'fa-solid fa-signal': SignalCellularAltIcon,

  // QR Code
  'fa-sharp fa-light fa-qrcode': QrCode2OutlinedIcon,

  'fas fa-info-circle': SettingsIcon,

  // Folder
  'fas fa-folder': FolderIcon,
  'fa fa-folder': FolderIcon,
  'fa-solid fa-folder-plus': CreateNewFolderIcon,

  // Pen / edit
  'fa-solid fa-pen-to-square': BorderColorOutlinedIcon,
  'fa-duotone fa-pen-to-square': BorderColorOutlinedIcon,
  'fa-duotone fa-solid fa-pen-to-square': BorderColorOutlinedIcon,
  'fa-solid fa-edit': BorderColorOutlinedIcon,
  'fa fa-pencil': EditIcon,
  'fa-solid fa-pen': EditIcon,
  'fa-regular fa-pen': EditIcon,

  // Trash / delete
  'fas fa-trash': DeleteIcon,
  'fa-solid fa-trash': DeleteIcon,
  'fa-regular fa-trash-alt': DeleteIcon,

  // Eraser
  'fa-solid fa-eraser': BackspaceOutlinedIcon,

  // Download / upload
  'fa-solid fa-download': FileDownloadOutlinedIcon,
  'fas fa-download': FileDownloadOutlinedIcon,
  'fa-solid fa-upload': FileUploadOutlinedIcon,

  // Sort direction carets
  'fas fa-caret-up': ArrowDropUpIcon,
  'fas fa-caret-down': ArrowDropDownIcon,

  // List
  'fa-solid fa-list': FormatListBulletedIcon,
  'fas fa-list': FormatListBulletedIcon,
  'fa-solid fa-list-check': PlaylistAddCheckIcon,
  'fa-solid fa-clipboard': AssignmentIcon,
  'fa-solid fa-file-lines': DescriptionIcon,

  // Layer
  'fa-sharp fa-regular fa-layer-plus': LibraryAddIcon,
  'fa-solid fa-layer-group': LayersOutlined,
  'fa-solid fa-stairs': StairsIcon,

  // Chart
  'fa-solid fa-chart-line': ShowChartIcon,
  'fa-duotone fa-solid fa-chart-simple': BarChartIcon,
  'fa-sharp fa-solid fa-chart-simple': BarChartIcon,
  'fa fa-chart-line': DashboardIcon,

  // graph chart picker (Diagramtype menu)
  'fa-sharp fa-solid fa-chart-bar': BarChartIcon,
  'fa-sharp fa-solid fa-chart-line': ShowChartIcon,
  'fa-sharp fa-solid fa-chart-pie': PieChartIcon,
  'fa-sharp fa-solid fa-chart-scatter': ScatterPlotIcon,
  'fa-sharp fa-solid fa-radar': RadarIcon,

  // analytics page (magnifying glass over a bar chart)
  'fa-solid fa-magnifying-glass-chart': QueryStatsIcon,

  // report toggle in building inspection (outlined file)
  'fa-regular fa-file': DescriptionOutlinedIcon,

  // Wind
  'fa-solid fa-wind': AirIcon,

  // Info
  'fa-solid fa-circle-info': InfoOutlinedIcon,
  'fa-solid fa-info-circle': InfoOutlinedIcon,

  // Close / times (v4 style)
  'fa fa-close': CloseIcon,
  'fa fa-times': CloseIcon,
  'fa-solid fa-times': CloseIcon,

  // Save (fas prefix)
  'fas fa-save': SaveIcon,

  // Eye / visibility
  'fas fa-eye': VisibilityIcon,
  'fas fa-eye-slash': VisibilityOffIcon,
  'fa-solid fa-eye-slash': VisibilityOffIcon,
  'fa-solid fa-eye': VisibilityIcon,

  // Search (v4 style)
  'fa fa-search': SearchOutlinedIcon,
  'fa-duotone fa-search': SearchOutlinedIcon,

  // Chevrons
  'fas fa-chevron-left': ChevronLeftIcon,
  'fa-solid fa-chevron-left': ChevronLeftIcon,
  'fa-solid fa-chevron-right': ChevronRightIcon,

  // User (fas prefix)
  'fas fa-user': PersonOutlinedIcon,

  // QR code
  'fa-solid fa-qrcode': QrCode2OutlinedIcon,

  // Arrows
  'fas fa-arrow-right': ArrowForwardIcon,
  'fas fa-arrow-left': ArrowBackIcon,
  'fa-sharp-duotone fa-light fa-arrow-left': ArrowBackIcon,
  'fa-regular fa-arrow-up-to-line': VerticalAlignTopIcon,
  'fa-sharp-duotone fa-light fa-up': ArrowUpwardIcon,

  // File types
  'fas fa-file-pdf': PictureAsPdfIcon,
  'fa-solid fa-file-pdf': PictureAsPdfIcon,
  'fas fa-file-video': VideoLibraryIcon,
  'fas fa-file-audio': LibraryMusicIcon,
  'fas fa-file': InsertDriveFileIcon,
  'fas fa-file-alt': DescriptionIcon,
  'fa-duotone fa-solid fa-file-text': DescriptionIcon,

  // Question
  'fas fa-question': HelpOutlineIcon,

  // Thermometer (v4 style)
  'fa fa-thermometer-empty': DeviceThermostatIcon,

  // v4 style aliases
  'fa fa-bolt': FlashOnSharpIcon,
  'fa fa-cog': SettingsIcon,
  'fa fa-gears': SettingsIcon,
  'fas fa-cogs': SettingsIcon,
  'fa fa-city': BusinessIcon,
  'fa fa-home': HomeIcon,
  'fa fa-cube': ViewInArIcon,
  'fa fa-camera': CameraAltOutlinedIcon,

  // Duotone aliases
  'fa-duotone fa-building': ApartmentIcon,
  'fa-duotone fa-solid fa-building-memo': NoteAltOutlinedIcon,
  'fa-duotone fa-solid fa-map': MapIcon,
  'fa-duotone fa-solid fa-distribute-spacing-horizontal': SpaceDashboardIcon,

  // Computer
  'fa-solid fa-computer': ComputerIcon,
  'fa-solid fa-display': DesktopWindowsOutlined,

  // Check (fas prefix)
  'fas fa-check': CheckOutlinedIcon,
  'fa-regular fa-check': CheckOutlinedIcon,
  'fa-regular fa-palette': PaletteOutlined,
  'fa-solid fa-check-double': DoneAllOutlinedIcon,

  // House variations
  'fa-sharp-duotone fa-regular fa-house': HomeIcon,

  // Solar panel
  'fa-solid fa-solar-panel': SolarPowerIcon,
  'fa-regular fa-solar-panel': SolarPowerOutlined,

  // Industry / utility
  'fa-regular fa-industry-windows': BusinessIcon,
  'fa-regular fa-utility-pole': ElectricalServicesIcon,
  'fa-regular fa-utility-pole-double': ElectricalServicesIcon,

  // Image
  'fa-solid fa-image': ImageIcon,

  // Ruler
  'fas fa-ruler': StraightenIcon,

  // Lock
  'fa fa-lock': LockIcon,
  'fa fa-unlock': LockOpenIcon,

  // Star / rating
  'fas fa-star': StarIcon,
  'far fa-star': StarBorderIcon,
  'fa-regular fa-star': StarBorderIcon,

  // Cloud upload
  'fas fa-cloud-upload-alt': CloudUploadOutlinedIcon,
  'fa-solid fa-cloud-upload-alt': CloudUploadOutlinedIcon,
  'fa-solid fa-cloud-upload': CloudUploadOutlinedIcon,

  // Calendar
  'far fa-calendar-alt': EventOutlinedIcon,
  'fa-regular fa-calendar-alt': EventOutlinedIcon,

  // Circle xmark
  'fa-regular fa-circle-xmark': HighlightOffIcon,

  // Square check (regular prefix)
  'fa-regular fa-square-check': CheckBoxOutlinedIcon,

  // Chart bar (solid prefix)
  'fa-solid fa-chart-bar': BarChartIcon,

  // Trash alt (solid prefix)
  'fa-solid fa-trash-alt': DeleteIcon,

  // Exclamation circle
  'fas fa-exclamation-circle': ErrorOutlineIcon,
  'fa-solid fa-exclamation-circle': ErrorOutlineIcon,

  // Regular variants
  'fa-regular fa-chart-line': DashboardIcon,
  'fa-regular fa-file-csv': DescriptionIcon,
  'fa-regular fa-image': ImageIcon,
  'fa-regular fa-search': SearchOutlinedIcon,

  // Solid variants
  'fa-solid fa-file': InsertDriveFileIcon,
  'fa-solid fa-badge-check': TaskAltIcon,
  'fa-solid fa-cloud-arrow-up': CloudUploadOutlinedIcon,
  'fa-solid fa-database': StorageIcon,
  'fa-solid fa-level-up-alt': ArrowUpwardIcon,

  // Snowflake / AC
  'fa-solid fa-snowflake': AcUnitIcon,
  'fa-regular fa-snowflake': AcUnitOutlined,
  'fa-regular fa-gauge-high': SpeedIcon,

  // Building columns
  'fa-solid fa-building-columns': AccountBalanceIcon,

  // Circle plus
  'fa-regular fa-circle-plus': AddCircleOutlineIcon,

  // House medical
  'fa-solid fa-house-medical': HomeIcon,

  // Arrows
  'fa-solid fa-arrow-right': ArrowForwardIcon,
  'fa-solid fa-arrow-left': ArrowBackIcon,
  'fa-solid fa-arrow-up': ArrowUpwardIcon,

  // Clipboard regular
  'fa-regular fa-clipboard': AssignmentOutlinedIcon,

  // Paperclip / attach
  'fa-solid fa-paperclip': AttachFileIcon,

  // Dollar
  'fa-solid fa-dollar-sign': AttachMoneyIcon,

  // Wand magic
  'fa-solid fa-wand-magic-sparkles': AutoAwesomeIcon,

  // Delete left
  'fa-regular fa-delete-left': BackspaceOutlinedIcon,

  // Battery
  'fa-solid fa-battery-three-quarters': Battery4BarOutlinedIcon,

  // Bars / menu
  'fa-solid fa-bars': MenuIcon,

  // Bolt regular
  'fa-regular fa-bolt': FlashOnSharpIcon,

  // Calculator
  'fa-solid fa-calculator': CalculateIcon,

  // Calendar regular
  'fa-regular fa-calendar': EventOutlinedIcon,

  // Code merge
  'fa-solid fa-code-merge': CodeIcon,

  // Circle xmark solid
  'fa-solid fa-circle-xmark': CancelIcon,

  // Layer group regular
  'fa-regular fa-layer-group': LayersIcon,

  // Circle check
  'fa-solid fa-circle-check': CheckCircleIcon,
  'fa-regular fa-circle-check': CheckCircleOutlineIcon,

  // Circle regular
  'fa-regular fa-circle': CircleOutlinedIcon,

  // Cloud regular
  'fa-regular fa-cloud': CloudOutlinedIcon,

  // Helmet safety / construction
  'fa-solid fa-helmet-safety': ConstructionIcon,

  // Copy regular
  'fa-regular fa-copy': ContentCopyIcon,
  'fa-solid fa-copy': ContentCopyIcon,

  // Square regular
  'fa-regular fa-square': CheckBoxOutlinedIcon,

  // Table cells
  'fa-solid fa-table-cells': DashboardIcon,

  // File lines regular
  'fa-regular fa-file-lines': DescriptionOutlinedIcon,

  // Temperature half
  'fa-solid fa-temperature-half': DeviceThermostatIcon,
  'fa-regular fa-temperature-half': DeviceThermostatIcon,
  'fa-duotone fa-temperature-half': DeviceThermostatIcon,

  // Grip vertical
  'fa-solid fa-grip-vertical': DragIndicatorIcon,

  // File pen
  'fa-solid fa-file-pen': EditNoteIcon,

  // Circle exclamation regular
  'fa-regular fa-circle-exclamation': ErrorOutlineIcon,

  // Charging station solid
  'fa-solid fa-charging-station': EvStationOutlinedIcon,

  // Calendar check
  'fa-regular fa-calendar-check': EventAvailableOutlinedIcon,

  // Compass
  'fa-regular fa-compass': ExploreOutlinedIcon,

  // File arrows
  'fa-regular fa-file-arrow-down': FileDownloadOutlinedIcon,
  'fa-regular fa-file-arrow-up': FileUploadOutlinedIcon,
  'fa-solid fa-file-arrow-up': FileUploadOutlinedIcon,
  'fa-solid fa-ellipsis': MoreHorizIcon,
  'fas fa-ellipsis': MoreHorizIcon,
  'fa-ellipsis': MoreHorizIcon,
  'fa-solid fa-user-plus': PersonAddIcon,
  'fas fa-user-plus': PersonAddIcon,
  'fa-user-plus': PersonAddIcon,
  'fa-solid fa-arrow-up-right-from-square': OpenInNewIcon,
  'fas fa-arrow-up-right-from-square': OpenInNewIcon,
  'fa-solid fa-up-right-from-square': OpenInNewIcon,
  'fa-solid fa-address-card': ContactPageIcon,
  'fa-regular fa-address-card': ContactPageIcon,

  // List ordered
  'fa-solid fa-list-ol': FormatListNumberedIcon,

  // Arrows up-down
  'fa-solid fa-arrows-up-down': HeightIcon,

  // Circle question
  'fa-regular fa-circle-question': HelpOutlineIcon,

  // Clock rotate left / history
  'fa-solid fa-clock-rotate-left': HistoryIcon,

  // Circle info regular
  'fa-regular fa-circle-info': InfoOutlinedIcon,

  // Blender / kitchen
  'fa-solid fa-blender': KitchenIcon,

  // Tag regular
  'fa-regular fa-tag': SellOutlinedIcon,

  // Book medical
  'fa-solid fa-book-medical': LibraryAddIcon,

  // Music
  'fa-solid fa-music': LibraryMusicIcon,

  // Sun regular
  'fa-regular fa-sun': WbSunnyOutlined,

  // Lightbulb regular
  'fa-regular fa-lightbulb': LightbulbOutlinedIcon,

  // Link
  'fa-solid fa-link': LinkIcon,
  'fa-solid fa-link-slash': LinkOffIcon,

  // Crosshairs / target (place / locate)
  'fa-solid fa-location-crosshairs': MyLocationIcon,

  // Fire
  'fa-solid fa-fire': LocalFireDepartmentOutlined,

  // Location dot
  'fa-solid fa-location-dot': LocationOnOutlined,
  'fa-regular fa-location-dot': LocationOnIcon,

  // Lock open solid
  'fa-solid fa-lock-open': LockOpenIcon,

  // Rotate / loop
  'fa-solid fa-rotate': LoopOutlinedIcon,
  'fa-solid fa-arrows-rotate': PublishedWithChangesIcon,

  // Arrow down wide short
  'fa-solid fa-arrow-down-wide-short': FormatListBulletedIcon,

  // Note sticky
  'fa-regular fa-note-sticky': NoteAltOutlinedIcon,

  // Droplet
  'fa-solid fa-droplet': OpacityIcon,

  // Users regular
  'fa-regular fa-users': PeopleOutlined,

  // Play
  'fa-solid fa-play': PlayArrowIcon,

  // Draw polygon
  'fa-light fa-draw-polygon': PolylineOutlinedIcon,

  // Power off
  'fa-solid fa-power-off': PowerIcon,

  // Gas pump
  'fa-solid fa-gas-pump': PropaneTankOutlinedIcon,

  // Globe
  'fa-solid fa-globe': PublicIcon,

  // Recycle
  'fa-solid fa-recycle': RecyclingIcon,

  // Rotate right / refresh
  'fa-solid fa-rotate-right': RefreshIcon,

  // Circle minus
  'fa-regular fa-circle-minus': RemoveCircleOutlineIcon,

  // Minus
  'fa-solid fa-minus': RemoveIcon,

  // Floppy disk / save
  'fa-solid fa-floppy-disk': SaveIcon,
  'fa-regular fa-floppy-disk': SaveOutlinedIcon,

  // Gear regular
  'fa-regular fa-gear': SettingsOutlined,

  // Comment sms
  'fa-regular fa-comment-sms': SmsOutlinedIcon,

  // Gauge high
  'fa-solid fa-gauge-high': SpeedIcon,

  // Ruler combined
  'fa-solid fa-ruler-combined': StraightenIcon,

  // Star solid
  'fa-solid fa-star': StarIcon,

  // Ruler regular
  'fa-regular fa-ruler': StraightenIcon,

  // Right left / swap
  'fa-solid fa-right-left': SwapHorizIcon,

  // Table
  'fa-solid fa-table': TableChartIcon,
  'fa-solid fa-file-excel': TableChartIcon,

  // Hand pointer
  'fa-regular fa-hand-pointer': TouchAppOutlinedIcon,
  'fa-solid fa-arrow-pointer': NearMeIcon,
  'fa-regular fa-arrow-pointer': NearMeIcon,

  // Magnet (snap)
  'fa-regular fa-magnet': JoinInnerOutlinedIcon,

  // Scissors (cut / split)
  'fa-regular fa-scissors': ContentCutOutlinedIcon,

  // Trend arrows
  'fa-solid fa-arrow-trend-down': TrendingDownIcon,
  'fa-solid fa-arrows-left-right': TrendingFlatIcon,
  'fa-solid fa-arrow-trend-up': TrendingUpIcon,
  'fa-light fa-arrows-left-right': MultipleStopOutlined,

  // Sliders regular
  'fa-regular fa-sliders': TuneOutlinedIcon,

  // Wave pulse / signal
  'fa-regular fa-wave-pulse': ShowChartIcon,
  'fa-solid fa-wave-pulse': ShowChartIcon,

  // Rotate left / undo
  'fa-solid fa-rotate-left': UndoIcon,

  // Film
  'fa-solid fa-film': VideoLibraryIcon,

  // Cube regular
  'fa-regular fa-cube': ViewInArOutlinedIcon,

  // Triangle exclamation
  'fa-solid fa-triangle-exclamation': WarningAmberIcon,

  // Droplet regular / water
  'fa-regular fa-droplet': WaterDropOutlined,

  // Couch
  'fa-solid fa-couch': WeekendIcon,

  // Window
  'fa-solid fa-window-maximize': WindowIcon,
  'fa-regular fa-window-maximize': WindowOutlinedIcon,
  'fa-solid fa-window-restore': WindowOutlinedIcon,
  'fa-regular fa-window-restore': WindowOutlinedIcon,

  // Zoom
  'fa-solid fa-magnifying-glass-plus': ZoomInIcon,
  'fa-solid fa-magnifying-glass-minus': ZoomOutIcon,

  // Paper plane
  'fa-solid fa-paper-plane': SendIcon,

  // Satellite dish / sensors
  'fa-solid fa-satellite-dish': SensorsIcon,

  // Magnifying glass regular
  'fa-regular fa-magnifying-glass': SearchOutlinedIcon,

  // Network wired solid
  'fa-solid fa-network-wired': DeviceHub,
  'fa-light fa-network-wired': DeviceHub,

  // Wrench
  'fa-solid fa-wrench': BuildOutlinedIcon,
  'fa-solid fa-screwdriver-wrench': HandymanOutlinedIcon,
  'fa-solid fa-gears': SettingsOutlined,

  // Briefcase regular
  'fa-regular fa-briefcase': BusinessCenterOutlinedIcon,

  'fa-solid fa-undo': RestoreIcon,
  'fa-light fa-cube': CropSquareIcon,
  'fa-light fa-circle': RadioButtonUncheckedIcon,
  'fa-light fa-check': CheckIcon,
  'fa-solid fa-sparkles': AutoAwesomeIcon,
  'fa-solid fa-ruler-triangle': SquareFootOutlined,
  'fa-solid fa-signal-stream': SensorsIcon,
  'fa-light fa-bell': NotificationsOutlinedIcon,
  'fa-light fa-clone': ContentCopyIcon,
  'fa-light fa-users': PeopleOutlined,
  'fa-light fa-clipboard-list': AssignmentOutlinedIcon,
  'fa-light fa-code': CodeIcon,
  'fa-light fa-cloud': CloudOutlinedIcon,
  'fa-light fa-bolt': FlashOnSharpIcon,
  'fa-light fa-building': ApartmentIcon,
  'fa-light fa-palette': PaletteOutlined,
  'fa-light fa-gear': SettingsOutlined,
  'fa-light fa-sensor': SensorsIcon,
  'fa-solid fa-sensor': SensorsIcon,
  'fa-light fa-temperature-half': DeviceThermostatIcon,
  'fa-light fa-arrows-up-down-left-right': OpenWithIcon,
  'fa-light fa-pen-ruler': DesignServicesIcon,
  'fa-solid fa-pen-ruler': DesignServicesIcon,
  'fa-solid fa-arrows-up-down-left-right': OpenWithIcon,
  'fa-sharp-duotone fa-light fa-sensor': SensorsOutlined,
  'fa-sharp-duotone fa-sensor': DeveloperBoard,
  'fa-sharp-duotone fa-solid fa-sensor-on': SettingsInputAntenna,
  'fa-sharp-duotone fa-solid fa-sensor-cloud': CloudQueueIcon,
  'fa-sharp-duotone fa-solid fa-microchip': MemoryIcon,
  'fa-sharp-duotone fa-solid fa-temperature-list': DeviceThermostatIcon,
  'fa-sharp-duotone fa-light fa-temperature-sun': SolarPowerIcon,
  'fa-sharp-duotone fa-regular fa-fan': ModeFanOffIcon,
  'fa-sharp-duotone fa-chart-diagram': DashboardIcon,
  'fa-sharp-duotone fa-solid fa-arrow-progress': LoopOutlinedIcon,
  'fa-sharp-duotone fa-regular fa-computer': ComputerIcon,
  'fa-sharp-duotone fa-solid fa-fire': Whatshot,
  'fas fa-folder-open': FolderOpenIcon,
  'fas fa-level-up-alt': Straight,
  'fa-light fa-comment-dots': SmsOutlinedIcon,
  'fa-light fa-folder-open': FolderCopy,
  'fa-light fa-sensor-cloud': CloudQueueIcon,
  'fa-light fa-tags': LocalOffer,
  'fa-light fa-exclamation-triangle': WarningAmberIcon,
  'fa-light fa-plug-circle-bolt': ElectricalServicesIcon,
  'fa-light fa-clipboard-check': EventAvailableOutlinedIcon,
  'fa-light fa-briefcase': BusinessCenterOutlinedIcon,
  'fa-light fa-key': KeyOutlinedIcon,
  'fa-solid fa-lock': LockIcon,
  'fa-regular fa-shapes': CategoryOutlined,
  'fa-solid fa-ruler': SquareFootOutlined,
  'fa-regular fa-building-columns': AccountBalanceOutlinedIcon,
  'fa-regular fa-fire': WhatshotOutlined,
  'fa-solid fa-house-chimney': HomeWorkOutlined,
  'fa-regular fa-couch': WeekendOutlined,
  'fa-solid fa-tag': LabelOutlined,
  'fa-solid fa-hashtag': TagOutlined,
  'fa-light fa-list-check': LowPriority,
  'fa-solid fa-comment-dots': SmsOutlinedIcon,
  'fa-regular fa-expand': Fullscreen,
  'fa-regular fa-search-plus': ZoomInIcon,
  'fa-regular fa-search-minus': ZoomOutIcon,
  'fa-regular fa-sync-alt': RefreshIcon,
  'fa-regular fa-arrow-down-to-line': FileDownload,
  'fa-regular fa-compress': FullscreenExit,
  'fa-regular fa-kitchen-set': KitchenOutlined,
  'fa-solid fa-draw-polygon': PolylineIcon,
  'fa-regular fa-screwdriver-wrench': HandymanOutlinedIcon,
  'fa-solid fa-wifi': WifiOutlined,
  'fa-solid fa-diagram-project': ShareOutlined,
  'fas fa-puzzle-piece': ExtensionOutlined,
  'fa-solid fa-shield-halved': SecurityOutlined,
  'fas fa-location-dot': LocationOnOutlined,
  'fa-light fa-lock-open': LockOpenIcon,
  'fa-light fa-lock': LockOutline,
  'fa-solid fa-scale-balanced': BalanceOutlined,
  'fa-regular fa-moon': DarkModeOutlined,
  'fa-regular fa-building-circle-xmark': DomainDisabled,
};

export default muiFallbackIconMap;
